/* global G */
import { setKey } from 'lib/util'

/**
 * Onboarding Action
 *
 * Saves the `nextRoute` in the action state so that we can redirect to it later
 * after confirming the onboarding.
 *
 * @param {Gaia.AppModule.Spec} module  the current module object
 * @returns {function(): function(*, ...[*]=): Promise<*[]>}
 */
// eslint-disable-next-line no-unused-vars
const actionFn = module => () => async (nextRoute, ...args) => {
  const actionState = module[G.STATE][G.ACTION][G.STATE]
  setKey(nextRoute, 'route', actionState)

  return args
}

export default actionFn
